// utils/ifoodWidgetUtils.js

const WIDGET_CONFIG = {
  widgetId: "353dbe5a-caf6-41f9-9628-74518b1d5956",
  storageKey: "ifoodWidgetState",
  sessionTimeout: 24 * 60 * 60 * 1000, // 24 hours in milliseconds
};

export const sortMerchantIds = (ids) => {
  if (!ids || !Array.isArray(ids)) {
    return [];
  }

  const uniqueIds = [...new Set(ids)];
  const sortedIds = uniqueIds.sort();

  return sortedIds;
};

export const generateMerchantIdsHash = (ids) => {
  const sortedIds = sortMerchantIds(ids);
  const hash = sortedIds.join(",");

  return hash;
};

export const loadWidgetState = () => {
  try {
    const savedState = sessionStorage.getItem(WIDGET_CONFIG.storageKey);

    if (!savedState) {
      return null;
    }

    const parsedState = JSON.parse(savedState);
    const currentTime = Date.now();
    const stateAge = currentTime - parsedState.timestamp;

    const isExpired = stateAge > WIDGET_CONFIG.sessionTimeout;

    if (isExpired) {
      clearWidgetState();
      return null;
    }

    return parsedState;
  } catch (error) {
    console.error("Error loading widget state:", error);
    clearWidgetState();
    return null;
  }
};

export const saveWidgetState = (merchantIdsHash) => {
  try {
    const stateToSave = {
      merchantIdsHash,
      timestamp: Date.now(),
      version: "1.0",
    };

    sessionStorage.setItem(
      WIDGET_CONFIG.storageKey,
      JSON.stringify(stateToSave)
    );

    return true;
  } catch (error) {
    console.error("Error saving widget state:", error);
    return false;
  }
};

export const clearWidgetState = () => {
  try {
    sessionStorage.removeItem(WIDGET_CONFIG.storageKey);
    return true;
  } catch (error) {
    console.error("Error clearing widget state:", error);
    return false;
  }
};

export const shouldReinitializeWidget = (currentMerchantIds) => {
  const persistedState = loadWidgetState();

  if (!persistedState) {
    return true;
  }

  const currentHash = generateMerchantIdsHash(currentMerchantIds);
  const needsReinitialization = persistedState.merchantIdsHash !== currentHash;

  return needsReinitialization;
};

export const getWidgetConfig = () => {
  return { ...WIDGET_CONFIG };
};

export default {
  sortMerchantIds,
  generateMerchantIdsHash,
  loadWidgetState,
  saveWidgetState,
  clearWidgetState,
  shouldReinitializeWidget,
  getWidgetConfig,
};
